import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { API } from 'src/app/services/constants';
import { ChatMessage, Conversation, ListMessagesResponse } from '../support-chat.model';

@Injectable({ providedIn: 'root' })
export class SupportChatService extends ApiService {
  list(options: { before?: string; beforeId?: string; limit?: number } = {}) {
    const params: Record<string, string> = {};
    if (options.before) params['before'] = options.before;
    if (options.beforeId) params['beforeId'] = options.beforeId;
    if (options.limit != null) params['limit'] = String(options.limit);
    return this.get<ListMessagesResponse>(API.supportChatMessages, { params });
  }

  send(text: string | undefined, files: File[] = [], audioDurationSec?: number) {
    const formData = new FormData();
    if (text) formData.append('text', text);
    for (const file of files) formData.append('files', file);
    if (audioDurationSec != null && Number.isFinite(audioDurationSec) && audioDurationSec > 0) {
      formData.append('audioDurationSec', String(Math.round(audioDurationSec)));
    }
    return this.post<ChatMessage>(API.supportChatMessages, { body: formData });
  }

  search(query: string, limit?: number) {
    const params: Record<string, string> = { q: query };
    if (limit != null) params['limit'] = String(limit);
    return this.get<{ conversation: any; messages: ChatMessage[] }>(
      API.supportChatMessages + '/search',
      { params }
    );
  }

  editMessage(id: string, text: string) {
    return this.patch<ChatMessage>(`${API.supportChatMessages}/${id}`, {
      body: { text }
    });
  }

  deleteMessage(id: string) {
    return this.delete<{ ok: true; messageId: string }>(`${API.supportChatMessages}/${id}`);
  }

  notifyTyping() {
    return this.post(API.supportChatTyping, { body: {} });
  }

  markRead(until?: string) {
    return this.post(API.supportChatRead, { body: until ? { until } : {} });
  }

  markAudioPlayed(messageId: string) {
    return this.post<{ ok: boolean }>(API.supportChatAudioPlayed(messageId), { body: {} });
  }

  setViewerState(open: boolean) {
    return this.post(API.supportChatViewerState, { body: { open } });
  }

  unreadCount() {
    return this.get<{ count: number; hasMessages: boolean }>(API.supportChatUnreadCount);
  }

  startNewConversation() {
    return this.post<Conversation>(API.supportChatNewConversation, { body: {} });
  }

  attachmentUrl(objectKey: string): string {
    // returns the path the browser hits to redirect to a signed url
    return API.supportChatAttachment(objectKey);
  }

  downloadAttachment(objectKey: string) {
    return this.get<Blob>(API.supportChatAttachment(objectKey), { responseType: 'blob' });
  }
}
